<template>
  <div>
    <!-- banner图展示 -->
    <div class="banner">

      <div class="swiper-container">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="(transit,index) in transitList" :key="index">
            <img :src="transit.img" />
            <div class="txt-box">
              <div v-html="transit.content" class="txt"></div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <!-- <div class="swiper-container" id="swiper-container">
        <div class="swiper-wrapper" style="position:relative;">
          <div v-for="(transit,index) in transitList" :key="index" class="swiper-slide">
            <img :src="transit.img" />
            <div class="txt-box">
              <div v-html="transit.content" class="txt"></div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <!-- 中间主题内容 -->
    <div class="content">
      <!-- 产品中心 -->
      <div class="products bg">
        <div class="wrap">
          <div class="title">
            <h2>产品中心</h2><span></span>
          </div>
          <div class="box-products home">
            <template v-for="(item, idx) in productList">
              <div @click="productDetailHandle(item.id)" :key="idx" :class="'item' + idx" v-if="idx < 7"
                class="item-com">
                <div class="img-com">
                  <img class="img-cover" :src="item.indexImg" alt="" />
                </div>
                <div class="i-bg"></div>
                <div class="con">
                  <h3>{{ item.title }}</h3>
                  <p class="ellipsis">{{ item.introduction }}</p>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="more-class">
        <a @click="moreProductHandler()" href="javascript:;" class="more-btn">查看更多</a>
      </div>

      <!-- 企业信息 -->
      <div class="information bg">
        <div class="about-us">
          <div class="bg">
            <img :src="information.imgUrl" alt="" srcset="">
          </div>
          <div class="box">
            <div class="txt-box">
              <div class="txt">
                <div v-html="information.content"></div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- 新闻动态 -->
      <div class="information bg">
        <div class="wrap">
          <div class="title">
            <h2>新闻资讯</h2><span></span>
          </div>
          <div class="box-news">
            <div class="content">
              <div @click="toNewsDetail(newList[0].id)" class="left">
                <div class="imgdiv">
                  <img class="img-cover" :src="newList[0].img" alt="" />
                </div>
                <p v-text="newList[0].title"></p>
                <span v-text="newList[0].publicTime"></span>
                <span class="ellipsis">{{ newList[0].summary}}</span>
              </div>
              <div class="right">
                <template v-for="(item, idx) in newList">
                  <div @click="toNewsDetail(item.id)" class="item" :key="idx" v-if="idx > 0 && idx < 5">
                    <div class="item-L">
                      <img class="img-cover" :src="item.img" alt="" />
                    </div>
                    <div class="item-R">
                      <p v-text="item.title" class="ellipsis"></p>
                      <span v-text="item.publicTime"></span>
                      <span class="ellipsis">{{item.summary}}</span>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="more-class">
            <a href="javascript:;" class="more-btn" @click="moreProjectHandler">查看更多</a>
          </div>
        </div>
      </div>

    </div>
    <!-- 底部 -->
  </div>
</template>

<script>
import {swiper, swiperSlide} from "vue-awesome-swiper"
import "swiper/dist/css/swiper.css"
import footerTemplate from './template/footer-template'
import headerTemplate from './template/header-template'
import { ApiWebIndexProductList } from '../api/product'
import { ApiWebArticleIndexNews } from '../api/news'
import { ApiWebCertificate } from '../api/company'
import { ApiWebIndex } from '../api/index'
export default {
  name: 'home',
  data () {
    return {
      // 产品中心list
      productList: [],
      // 新闻列表
      newList: [],
      // 企业信息
      information: {},
      // 过渡
      transitList: [],
      // 证书
      certificateList: [],
      swiperOption: {
        loop: true, //环路，让Swiper看起来是循环的
        speed: 800, //速度
        freeMode: false, //根据惯性滑动可能不止一格且不会贴合
        observer: false, //修改swiper自己或子元素时，自动初始化swiper
        autoplay: {
          delay: 3000, //自动切换的时间间隔，单位ms
          disableOnInteraction: false //用户操作swiper之后，是否禁止autoplay
        },
        autoplay: 2000, //自动切换
        noSwiping: true, //设为true时，可以在slide上（或其他元素）增加类名'swiper-no-swiping'，使该slide无法拖动
        autoHeight: true, //自动高度
        spaceBetween: 0, //两个slide的间隔
        slidesPerView: 'auto', //设置slider容器能够同时显示的slides数量
        observeParents: true //当Swiper的父元素变化时Swiper更新。
      }
    }
  },
  components: {
    swiper,
    swiperSlide,
    headerTemplate,
    footerTemplate
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  created () {
    // 获取产品中心list
    this.initIndex()
    this.initProduct()
  },
  methods: {
    /**
     * 获取产品中心list
     */
    initProduct () {
      ApiWebIndexProductList().then(({data}) => {
        if (data && data.status === 0) {
          this.productList = data.data
          if (this.productList.length < 6) {
            for (let i = 0; i < 6 - this.productList.length; i++) {
              this.productList.push({id: null, title: '', indexImg: '', introduction: ''})
            }
          }
          this.$nextTick(() => {
            this.initNews()
          })
        }
      })
    },
    /**
     * 新闻列表
     */
    initNews () {
      ApiWebArticleIndexNews().then(({data}) => {
        if (data && data.status === 0) {
          this.newList = data.data
          if (this.newList.length < 5) {
            let newList = this.newList
            let len = 5 - newList.length
            for (let i = 0; i < len; i++) {
              let news = {id: null, title: '', publicTime: '', img: ''}
              newList.push(news)
            }
            this.newList = newList
          }
        }
      })
    },
    // 首页-企业信息-证书
    initCertificate () {
      ApiWebCertificate().then(({data}) => {
        if (data && data.status === 0) {
          this.certificateList = data.data
          this.$nextTick(() => {
            var mySwiper3 = new Swiper('#company',{
              effect : 'coverflow',
              slidesPerView: 3,
              centeredSlides: true,
            })
          })
        }
      })
    },
    /**
     * 首页其他信息
     */
    initIndex () {
      ApiWebIndex().then(({data}) => {
        if (data && data.status === 0) {
          let res = data.data
          this.information = res.information
          this.transitList = res.transits
        }
      })
    },
    /**
     * 查看产品详情
     * id => 产品id
     */
    productDetailHandle (id) {
      this.$store.commit('product/setProductId', id)
      this.$router.push({ name: 'productDetail', params: { productId: id } })
    },
    /**
     * 跳转新闻详情页面
     * @param id 新闻id
     */
    toNewsDetail (id) {
      this.$store.commit('news/setNewsId', id)
      this.$router.push({ name: 'newsDetail', params: { newsId: id } })
    },
    /**
     * 新闻-查看更多
     */
    moreProjectHandler () {
      this.$router.push({name: 'news'})
    },
    /**
     * 产品中心 - 更多
     */
    moreProductHandler () {
      this.$router.push({name: 'product'})
    },
  }
}
</script>

<style scoped lang="less">

  @import '../assets/style/index.less';
</style>
<style lang="less">


.swiper-wrapper .txt-box {
  top: 275px;
}
.information .txt-box {
  top: 5px;
}
.swiper-wrapper, .information {
  .txt-box {
    position: absolute;
    width: 100%;
    left: 0px;
    .txt {
      width: 1552px;
      height: 240px;
      margin: 0 auto;
      position: relative;
      p{
        color: #ffffff;
        font-size: 43px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 43px;
        height: 43px;
        margin-bottom: 25px;
        &:first-child{
          height: 29px;
          line-height: 43px;
          font-size: 36px;
        }
      }
      &::before {
        position: absolute;
        width: 76px;
        height: 4px;
        content: ' ';
        display: block;
        top: -64px;
        left: 0;
        background: #DC252B;
      }
    }
  }
}
</style>

<style scoped >

/* .swiper-container{
  position: relative;
  width: 100%;
}   */
</style>


// WEBPACK FOOTER //
// src/components/home.vue